import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const dnaMwTool: Tool = {
  id: "dna-rna-molecular-weight",
  name: () => m.dnamw_tool_name(),
  description: () => m.dnamw_tool_description(),
  icon: "🧬",
  basePath: "/dna-rna-molecular-weight",
  status: "stable",
  tags: [
    "bioinformatics",
    "dna",
    "rna",
    "science",
    "molecular-weight",
    "oligo",
  ],
};
